import axios from 'axios'
import Vue from 'vue'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'

/**
 * @method connectBzbsGet
 * @method connectBzbsPost
 * @method connectBzbsDelete
 * @method connectBzbsGetBlob
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },
  /**
   * Connect Buzzebees GET method
   * @param {string} url string url
   * @param {string} token (optional)
   * @param {object} data (optional)
   * @return Promise
   */
  connectBzbsGet: function (url, token, data, appId) {
    var header = {}
    if (data == null) {
      data = {}
    }
    // data.device_app_id = this.config().client_id;
    if (token != null) {
      if (appId) {
        header = { Authorization: 'token ' + token, 'App-Id': appId }
      } else {
        header = { Authorization: 'token ' + token }
      }
    } else {
      if (appId) {
        header = { 'App-Id': appId }
      }
    }
    return axios({
      method: 'get',
      url: url,
      params: data,
      headers: header,
    })
  },
  connectBzbsGetForgot: function (url, token, data) {
    var header = {}
    if (data == null) {
      data = {}
    }
    var appId = ''
    var BzbsUser = Cache.get('BzbsUser_' + Account.getCacheCustom('app_id'))
    if (BzbsUser != null) {
      appId = BzbsUser.appId
    }

    if (token != null) {
      header = { Authorization: 'token ' + token, 'App-Id': appId }
    } else {
      header = { 'App-Id': appId }
    }
    return axios({
      method: 'get',
      url: url,
      params: data,
      headers: header,
    })
  },
  connectBzbsPostForgot: function (url, token, data) {
    var header = {}
    if (data == null) {
      data = {}
    }
    var appId = ''
    var BzbsUser = Cache.get('BzbsUser_' + Account.getCacheCustom('app_id'))
    if (BzbsUser != null) {
      appId = BzbsUser.appId
    }

    if (token != null) {
      header = { Authorization: 'token ' + token, 'App-Id': appId }
    } else {
      header = { 'App-Id': appId }
    }

    var form = this.arrToFormData(data)
    return axios({
      method: 'post',
      url: url,
      data: form,
      headers: header,
    })
  },
  /**
   * Connect Buzzebees DELETE method
   * @param {string} url string url
   * @param {string} token (optional)
   * @param {object} data (optional)
   * @return Promise
   */

  connectBzbsDelete: function (url, token, data) {
    var header = {
      Language: Vue.$cookies.get('BzbsLocale'),
    }
    if (data == null) {
      data = {}
    }

    var form = this.arrToFormData(data)

    // data.device_app_id = this.config().client_id;
    if (token != null) {
      header.Authorization = 'token ' + token
    }
    return axios({
      method: 'delete',
      url: url,
      data: form,
      headers: header,
    })
  },

  /**
   * Connect Buzzebees POST method
   * @param {string} url string url
   * @param {string} token (optional)
   * @param {object} data parameter
   * @param {string} uploadKey (optional)
   * @param {object} uploadfile (optional)
   * @return Promise
   */
  connectBzbsPostPhotos: function (url, token, data, uploadKey, uploadfile) {
    var header = {
      Language: Vue.$cookies.get('BzbsLocale'),
    }

    var form = new FormData()
    form.append('campaign_id', data.campaign_id)
    for (var i in data.campaign_picture) {
      for (var key in data.campaign_picture[i]) {
        if (key === 'picture_id') {
          if (data.campaign_picture[i].picture_id)
            form.append(
              `campaign_picture[${i}].${key}`,
              data.campaign_picture[i][key],
            )
        } else {
          form.append(
            `campaign_picture[${i}].${key}`,
            data.campaign_picture[i][key],
          )
        }
      }
    }
    // return form

    if (uploadKey) form.append(uploadKey)
    if (uploadfile) {
      for (var k in uploadfile) {
        if (typeof uploadfile[k] != 'undefined') {
          form.append(`campaign_picture[${k}].picture_file`, uploadfile[k])
        }
      }
    }

    if (token != null) {
      header.Authorization = 'Bearer ' + token
    }

    return axios({
      method: 'post',
      url: url,
      data: form,
      headers: header,
    })
  },
  connectBzbsPost: function (
    url,
    token,
    data,
    uploadKey,
    uploadfile,
    appId = null,
  ) {
    var header = {
      Language: Vue.$cookies.get('BzbsLocale'),
    }

    var BzbsUser = Cache.get('BzbsUser_' + Account.getCacheCustom('app_id'))
    if (!url.includes('/auth/login')) {
      if (BzbsUser != null) {
        console.log('BzbsUser != null')
        data.device_app_id = BzbsUser.appId
      } else {
        data.device_app_id = this.config().client_id
      }
    }

    var form = this.arrToFormData(data)
    if (uploadKey) form.append(uploadKey)
    if (uploadfile) {
      for (var i in uploadfile) {
        form.append(i, uploadfile[i])
      }
    }

    if (token != null) {
      if (appId) {
        header = { Authorization: 'token ' + token, 'App-Id': appId }
      } else {
        header = { Authorization: 'token ' + token }
      }
    } else {
      if (appId) {
        header = { 'App-Id': appId }
      }
    }

    return axios({
      method: 'post',
      url: url,
      data: form,
      headers: header,
    })
  },
  connectBzbsPostAppId: function (url, token, data, uploadKey, uploadfile) {
    var header = {
      'App-Id': Account.getCacheCustom('app_id'),
    }

    // data.device_app_id = this.config().client_id;

    var form = this.arrToFormData(data)

    if (uploadKey) form.append(uploadKey, uploadfile)

    if (token != null) {
      header.Authorization = 'token ' + token
    }

    return axios({
      method: 'post',
      url: url,
      data: form,
      headers: header,
    })
  },
  connectBzbsPutPhoto: function (url, token, data, uploadKey, uploadfile) {
    var header = {
      Language: Vue.$cookies.get('BzbsLocale'),
    }
    // data.device_app_id = this.config().client_id;
    var form = this.arrToFormData(data)
    if (uploadKey) form.append(uploadKey)
    if (uploadfile) {
      for (var i in uploadfile) {
        form.append(i, uploadfile[i])
      }
    }

    if (token != null) {
      header.Authorization = 'Bearer ' + token
    }

    return axios({
      method: 'put',
      url: url,
      data: form,
      headers: header,
    })
  },
  connectBzbsPostBody: function (url, token, data) {
    var header = {
      'Content-Type': 'application/json',
      Language: Vue.$cookies.get('BzbsLocale'),
    }

    if (token != null) {
      header.Authorization = 'Bearer ' + token
    }

    return axios({
      method: 'post',
      url: url,
      data,
      headers: header,
    })
  },
  /**
   * Convert data to array of FormData
   * @param {Array|Dictionary} arr
   */
  arrToFormData: function (arr) {
    var form = new FormData()
    for (var i in arr) {
      form.append(i, arr[i])
    }
    return form
  },

  /**
     * Connect Buzzebees GET Blob
     * @param {string} url string url

     * @return Promise
     */
  connectBzbsGetBlob: function (url) {
    return axios({
      method: 'get',
      url: url,
    })
  },
  connectBzbsGetAccessAllow: function (url, data) {
    if (data == null) {
      data = {}
    }
    var header = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    }
    return axios({
      method: 'get',
      url: url,
      params: data,
      headers: header,
    })
  },

  connectBzbsPut: function (url, token, data) {
    var header = {
      Language: Vue.$cookies.get('BzbsLocale'),
      'Content-Type': 'application/json',
    }

    if (token != null) {
      header.Authorization = 'Bearer ' + token
    }

    return axios({
      method: 'put',
      url: url,
      data,
      headers: header,
    })
  },
}
